var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.objectFull)?_c('cbs-object',{attrs:{"objectid":_vm.objectid,"object-full":_vm.objectFull},on:{"close":_vm.onClose}}):_vm._e(),_c('cbs-data-object',{attrs:{"hide":"","objectid":_vm.objectid},on:{"load":_vm.onObjectLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }